import { Component, OnInit } from '@angular/core'
import { GlobalService } from '../../../services/global.service'

@Component({
    selector: 'app-enterprise-footer',
    templateUrl: './enterprise-footer.component.html',
    styleUrls: ['./enterprise-footer.component.scss'],
})
export class EnterpriseFooterComponent implements OnInit {
    enterpriseKey: string = 'parkupp'

    constructor(public globalService: GlobalService) {
        this.enterpriseKey = globalService.enterpriseKey
    }

    ngOnInit(): void {}
}
